import React from "react";
import { roleValues } from "../data/content";

export default function ConnectsNeeds() {
  return (
    <section className="section-py">
      <div className="container text-center">
        <h2 className="section-title">
          Selectezi Connects The Needs Behind The Business
        </h2>
        <p className="section-subtitle">
          Tailored values engineered for every enterprise scale and
          stakeholder role
        </p>

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 mt-4 text-start">
          {roleValues.map((role) => {
            const Icon = role.icon;
            return (
              <div className="col" key={role.title}>
                <div className="role-card">
                  <div className="icon-wrap">
                    <Icon size={22} />
                  </div>
                  <h4>{role.title}</h4>
                  <p>{role.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
